import { AnyAction, configureStore, Dispatch, Middleware } from '@reduxjs/toolkit';
import { createLogger } from "redux-logger";
import thunkMiddleware from "redux-thunk";
import rootReducer from '../reducers';
import { buildMode } from "../../common/environment";

const middleware: Middleware<{}, any, Dispatch<AnyAction>>[] = [];

if (buildMode === "development") {
    const loggerMiddleware = createLogger({ level: "info", collapsed: true });
    middleware.push(loggerMiddleware)
}
// const enhancer = applyMiddleware(thunkMiddleware);
middleware.push(thunkMiddleware)

export default configureStore({
    reducer: rootReducer,
    middleware: middleware,
});
